export default {
  name: 'SimpleModal',
  props: {
    val: Object
  },
  mounted () {
    this.$refs.focus.focus();
  },
  methods: {
    close() {
      this.val.closeFunc();
      this.$emit('close');
    }
  },
  computed: {
    replacedMessage: {
      get: function() {
        return this.$options.filters.replaceLineBreaks(this.val.message);
      },
      set: function(val) {
        this.val.message = val;
      },
    },
  }
}